import { Controller } from "@hotwired/stimulus"

// Watches a GeoJSON textarea and (debounced) dispatches a redraw event that the
// map renderer (custom-map-layer#redrawLayer) consumes. Provider-agnostic: it only
// parses text and fires an event, so it survives the Google→Mapbox migration.
export default class extends Controller {
  static targets = ["source"]
  static values = { debounce: { type: Number, default: 300 } }

  input() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.render(), this.debounceValue)
  }

  render() {
    let geojson
    try {
      geojson = JSON.parse(this.sourceTarget.value)
    } catch (_e) {
      return // ignore transient invalid JSON while typing
    }
    this.dispatch("changed", { detail: { geojson } })
  }
}
